export default {"src":"/planos/_next/static/media/money-coin.2f9dc4e6.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};